import { commonRequest } from '@/utils/request'

const actions = {
  save: ({ commit }, data) => commonRequest({ data, url: '/special/save' }),
  list: ({ commit }, data) => commonRequest({ data, url: '/special/list' }),
  remove: ({ commit }, data) => commonRequest({ data, url: '/special/remove' }),
  photo: ({ commit }, data) => commonRequest({ data, url: '/special/photo' }),
}

export default {
  namespaced: true,
  actions,
}
